import { eTitleSearchStatus, vendorInitialStatuses } from '../order/title/eTitleSearchStatus';
import { IVendorOrdersResponse } from './IVendorOrders';
import { IVendorPayoffsResponse } from './IVendorPayoffs';
import { IVendorTaxCertificationsResponse } from './IVendorTaxCertifications';

export interface ISearchOrdersSettingsData {
  fileNumber?: string;
  page: number;
  pageSize: number;
  statuses: eTitleSearchStatus[];
}

export const createDefaultSearchOrdersSettingsData = (): ISearchOrdersSettingsData => ({
  page: 0,
  pageSize: 50,
  statuses: vendorInitialStatuses,
});

export const convertFromVendorOrdersResponseToSearchOrdersSettingsData = (
  data: IVendorOrdersResponse | IVendorPayoffsResponse | IVendorTaxCertificationsResponse,
  statuses?: eTitleSearchStatus[]
): ISearchOrdersSettingsData => ({
  page: data.page,
  pageSize: data.pageSize,
  statuses: statuses || vendorInitialStatuses,
});
